import { useAddOnPurchaseCartList } from "./add-on-purchase/useAddOnPurchaseCartList";
import { ADD_ON_PURCHASE_TYPE } from "../activity/add-on-purchase/types";
// write a component name ProductCard that renders a div element with the class name "product-card" and the text "Product Card"
// export the component as default

import React, { useEffect, useState, useContext } from "react";
import ProductGroup from "./ProductGroup";
import exchangeIcon from "../../images/exchange.svg";
import activityIcon from "../../images/activity.svg";
import axios from "axios";
import {
  cartUrl,
  ACTIVITY_NO_PERMISSION_STATUS_VALUE,
  getActivityNoPermissionStatusLabel,
} from "../../utils/constant";
import { getAuthToken } from "../../utils/common";
import { AppContext } from "../../store";
import Loading from "../common/Loading";
import { getAllCartItemIds, getCartItemIds } from "../../utils/activityHelper";
import { getSelectedSTObj } from "../../utils/addressUtils";
import { message } from "antd";

const CartSection: React.FC<any> = (props: any) => {
  const { activityId, loadingCart, activityDetail, allChecked, setAllChecked } =
    props;
  const [loading, setLoading] = useState<boolean>(true);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const {
    loginState,
    cartData,
    setCartData,
    activityPermissionMeta,
    refreshCart,
    checkedCartItems,
    setCheckedCartItems,
  } = useContext(AppContext);
  const activityNoPermissionLabel = getActivityNoPermissionStatusLabel(
    activityPermissionMeta.activityId === activityId
      ? activityPermissionMeta.customerDataType
      : undefined
  );
  const isAddOnPurchase = activityDetail?.activityBasicType === ADD_ON_PURCHASE_TYPE;
  const addonLoading = useAddOnPurchaseCartList({ activityId, enabled: isAddOnPurchase,
    selectAllOnFirstLoad: allChecked });
  const activityData = cartData.activity;
  const exchangeData = cartData.exchange;
  const exchangeItemIds = getCartItemIds(exchangeData).ids;
  const noExchangeItems = !exchangeData || !exchangeItemIds.length;
  const activityItemIds = getCartItemIds(activityData).ids;
  const noActivityItems = !activityData || !activityItemIds.length;
  console.log("noExchangeItems", noExchangeItems);

  useEffect(() => {
    if (isAddOnPurchase) {
      setLoading(false);
      return;
    }
    console.log("CartSection rendered");
    if (loginState.status !== "login") return;
    setLoading(true);
    const selectedST = getSelectedSTObj(loginState);
    let reqBody = {
      activityId: activityId,
      shipTo: selectedST?.accountNumber,
      selectAll: firstLoad,
      cartIds: Array.from(checkedCartItems),
    };
    console.log("refreshCartData reqBody", reqBody);
    axios(cartUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: reqBody,
    })
      .then((res) => {
        const respData = res.data;
        console.log("cart data", respData);
        console.log("firstLoad", firstLoad);
        if (respData.status === "success") {
          setCartData(respData.data);
          const ids = getAllCartItemIds(respData.data);
          console.log("ids", ids);
          if (firstLoad) {
            setFirstLoad(false);
            console.log("firstload cartdata");
            allChecked && setCheckedCartItems(new Set(ids));
          }
        } else if (respData.status === ACTIVITY_NO_PERMISSION_STATUS_VALUE) {
          message.warning(activityNoPermissionLabel);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [loginState, activityId, refreshCart, isAddOnPurchase]);

  useEffect(() => {
    const ids = getAllCartItemIds(cartData);
    if (ids.length === checkedCartItems.size) {
      console.log("checkedCartItems", "all checked");
      setAllChecked(true);
    } else {
      console.log("checkedCartItems", "not all checked");
      setAllChecked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData, checkedCartItems]);

  return (
    <div className={isAddOnPurchase ? "cartWrapper addOnPurchaseCart" : "cartWrapper"}>
      {(loading || addonLoading || loadingCart) && <Loading overCart={true} />}
      <div className="cartTabWrapper">
        <div className="sectionWrapper">
          <div className="sectionHead">
            <img alt="" src={activityIcon}></img>
            <div className="title">{activityDetail?.activityTypeName}</div>
          </div>
          <div
            className={
              activityData?.matchPromo ? "sectionDesc" : "sectionDesc highlight"
            }
          >
            {activityDetail?.activityTypeDescription}
            {noActivityItems && (
              <>
                <span>，</span>
                <span
                  className="textLink noWrap"
                  onClick={() => {
                    props.setFilteredCategories({
                      activeTab: "activity",
                      filteredMap: new Map(),
                      pageConf: {
                        pageNum: 1,
                        pageSize: props.filteredCategories.pageSize,
                      },
                    });
                    props.setOpenCartDrawer(false);
                  }}
                >
                  {" "}
                  前往选择
                </span>
              </>
            )}
          </div>
        </div>
        {activityData?.productGroup.map((item: any, index: number) => {
          return (
            <ProductGroup
              key={index}
              cartData={cartData}
              tab="activity"
              groupItem={item}
              isAddOnPurchase={isAddOnPurchase}
              noTabData={noActivityItems}
              // groups={activityData.productGroup}
              setLoadingCart={setLoading}
              {...props}
            ></ProductGroup>
          );
        })}
      </div>
      {activityDetail?.activityBasicType === "low_exchange" && (
        <div className="cartTabWrapper">
          <div className="sectionWrapper">
            <div className="sectionHead">
              <img alt="" src={exchangeIcon}></img>
              <div className="title">{activityDetail?.exchangeTypeName}</div>
            </div>
            <div
              className={
                exchangeData?.matchPromo
                  ? "sectionDesc"
                  : "sectionDesc highlight"
              }
            >
              <div>
                {activityDetail?.exchangeTypeDescription}
                {noExchangeItems && (
                  <>
                    <span>，</span>
                    <span
                      className="textLink noWrap"
                      onClick={() => {
                        props.setFilteredCategories({
                          activeTab: "exchange",
                          filteredMap: new Map(),
                          pageConf: {
                            pageNum: 1,
                            pageSize: props.filteredCategories.pageSize,
                          },
                        });
                        props.setOpenCartDrawer(false);
                      }}
                    >
                      {" "}
                      前往选择
                    </span>
                  </>
                )}
              </div>
              { ((!cartData.matchStatus || !cartData.hasFurtherPromotion) && exchangeData?.exchangeMaxQty) ? (
                <div>最多可换购{exchangeData?.exchangeMaxQty}件</div>
              ) : null}
            </div>
          </div>
          {exchangeData?.productGroup.map((item: any) => {
            return (
              <ProductGroup
                cartData={cartData}
                tab="exchange"
                groupItem={item}
                isAddOnPurchase={isAddOnPurchase}
                noTabData={noExchangeItems}
                // groups={exchangeData.productGroup}
                setLoadingCart={setLoading}
                {...props}
              ></ProductGroup>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CartSection;
